import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import useQuery from '../hooks/useQuery';

const withQueryParams = (Component: any) => (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const searchParams = useQuery();

  return (
    <Component
      {...props}
      queryParams={searchParams}
      params={params}
      navigate={navigate}
      location={location}
    />
  );
};
export default withQueryParams;
